import { render, staticRenderFns } from "./TakeCombinationTicket.vue?vue&type=template&id=b6166650&scoped=true&"
import script from "./TakeCombinationTicket.vue?vue&type=script&lang=js&"
export * from "./TakeCombinationTicket.vue?vue&type=script&lang=js&"
import style0 from "./TakeCombinationTicket.vue?vue&type=style&index=0&id=b6166650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6166650",
  null
  
)

export default component.exports